const actionKeys = {
  setMyTasksCount: 'SetMyTasksCount',
  incrementMyTasksCount: 'IncrementMyTasksCount',
  decrementMyTasksCount: 'DecrementMyTasksCount',
  setAllTasksCount: 'SetAllTasksCount',
  incrementAllTasksCount: 'IncrementAllTasksCount',
  decrementAllTasksCount: 'DecrementAllTasksCount',
};

const setMyTasksCount = (count) => async (dispatch) => {
  dispatch({
    type: actionKeys.setMyTasksCount,
    payload: {
      count,
    },
  });
};

const incrementMyTasksCount = () => async (dispatch) => {
  dispatch({
    type: actionKeys.incrementMyTasksCount,
  });
};

const decrementMyTasksCount = () => async (dispatch) => {
  dispatch({
    type: actionKeys.decrementMyTasksCount,
  });
};

const setAllTasksCount = (count) => async (dispatch) => {
  dispatch({
    type: actionKeys.setAllTasksCount,
    payload: {
      count,
    },
  });
};

const incrementAllTasksCount = () => async (dispatch) => {
  dispatch({
    type: actionKeys.incrementAllTasksCount,
  });
};

const decrementAllTasksCount = () => async (dispatch) => {
  dispatch({
    type: actionKeys.decrementAllTasksCount,
  });
};

const reducer = (state = {myTasksCount: 0, allTasksCount: 0}, action) => {
  switch (action.type) {
    case actionKeys.setMyTasksCount:
      return {
        ...state,
        myTasksCount: action.payload.count,
      };
    case actionKeys.incrementMyTasksCount:
      return {
        ...state,
        myTasksCount: state.myTasksCount + 1,
      };
    case actionKeys.decrementMyTasksCount:
      return {
        ...state,
        myTasksCount: Math.max(0, state.myTasksCount - 1),
      };
    case actionKeys.setAllTasksCount:
      return {
        ...state,
        allTasksCount: action.payload.count,
      };
    case actionKeys.incrementAllTasksCount:
      return {
        ...state,
        allTasksCount: state.allTasksCount + 1,
      };
    case actionKeys.decrementAllTasksCount:
      return {
        ...state,
        allTasksCount: Math.max(0, state.allTasksCount - 1),
      };
    default:
      return state;
  }
};

export default {
  actions: {
    setMyTasksCount,
    incrementMyTasksCount,
    decrementMyTasksCount,
    setAllTasksCount,
    incrementAllTasksCount,
    decrementAllTasksCount,
  },
  reducer: reducer,
  defaultState: {
    myTasksCount: 0,
    allTasksCount: 0,
  },
};
